import { AfterViewInit, Directive, ElementRef, HostListener, Injector, Input } from '@angular/core';
import AudioHelper from '../../audio/helpers/audio.helper';

@Directive({
  selector: '[play-audio]',
  exportAs: 'playAudio',
})
export class PlayAudioDirective implements AfterViewInit {

  @Input() public inputAction: string;
  @Input() public onClickSound: string;
  @Input() public onEnterSound: string;
  @Input() public onOutSound: string;
  @Input() public onDownSound: string;
  @Input() public onUpSound: string;
  @Input() public onTouchStartSound: string;
  @Input() public onTouchEndSound: string;
  @Input() public onShowSound: string;
  @Input() public muteAudio: boolean;

  private audioHelper: AudioHelper;

  /**
   * Constructor
   *
   * @param {ElementRef} element
   * @param injector
   */
  public constructor(public element: ElementRef, public injector: Injector) {
    this.audioHelper = injector.get(AudioHelper);
  }

  /**
   * Play sound on mouse click
   */
  @HostListener('click', ['$event'])
  public onClick() {

    if (this.onClickSound !== undefined) {
      if (this.muteAudio) {
        this.audioHelper.setMasterVolume(0);
      }
      this.audioHelper.playAudio(this.onClickSound);
    }

  }

  /**
   * Play sound on mouse enter
   */
  @HostListener('mouseenter', ['$event'])
  public onEnter() {
    if (this.onEnterSound !== undefined) {
      this.audioHelper.playAudio(this.onEnterSound);
    }
  }

  /**
   * Play sound on mouse out
   */
  @HostListener('mouseout', ['$event'])
  public onOut() {
    if (this.onOutSound !== undefined) {
      this.audioHelper.playAudio(this.onOutSound);
    }

  }

  /**
   * Play sound on mouse down
   */
  @HostListener('mousedown', ['$event'])
  public onDown() {
    if (this.onDownSound !== undefined) {
      this.audioHelper.playAudio(this.onDownSound);
    }

  }

  /**
   * Play sound on mouse up
   */
  @HostListener('mouseup', ['$event'])
  public onUp() {
    if (this.onUpSound !== undefined) {
      this.audioHelper.playAudio(this.onUpSound);
    }

  }

  /**
   * Play sound on touch start
   */
  @HostListener('touchstart', ['$event'])
  public onTouchStart() {
    if (this.onTouchStartSound !== undefined) {
      this.audioHelper.playAudio(this.onTouchStartSound);
    }

  }

  /**
   * Play sound on touch end
   */
  @HostListener('touchend', ['$event'])
  public onTouchEnd() {
    if (this.onTouchEndSound !== undefined) {
      this.audioHelper.playAudio(this.onTouchEndSound);
    }

  }

  /**
   * Onload Sound
   */
  public ngAfterViewInit(): void {
    if (this.onShowSound !== undefined) {
      this.audioHelper.playAudio(this.onShowSound);
    }
  }

}
